export const APIURI = "https://api.escapely.rlogical.com"; //dev
export const SOCKET_URI = "wss://ws-escapley.immodesta.com"; //dev

// export const APIURI = "http://localhost:8080"; //dev
// export const SOCKET_URI = "wss://ws-escapely-prod.immodesta.com"; //dev
export const REDIRECT_SEQUENCE_NO = 2;
export const REDIRECT_ON_MODE = 'easy'
// export const APIURI = "http://localhost:8080"; //prod

export const customStyleGameIds = [
  "687ab3507d94cb1af7103552",
  // "6810c871d0ea1202b52128a3",
  // "68372f157d94cb1af7b2f1b1",
  // "66588fc326f79c02be440aa3"
  "6810c871d0ea1202b52128a3",
];

export const blueThemePodIds = [
  "68fb552014e1fb0880a5d851", //testing pod id
  "69394571c323dc02b5cd4375", //testing pod id
  "693944e8c323dc02b5cd42bc", //game id
  "6920ebcfc323dc02b5a89b7a", // client game id
  "69324041c323dc02b5b86067", //client pod id
];
